import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ParallaxImage = ({ src, alt, className = "", testid, children }) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);

    return (
        <div ref={ref} className={`sf-image-frame group ${className}`} data-testid={testid}>
            <motion.div style={{ y }} className="absolute -inset-y-[12%] inset-x-0">
                <img src={src} alt={alt} className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700" />
            </motion.div>
            {children}
        </div>
    );
};
